import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-my-button-dialog',
  templateUrl: './my-button-dialog.component.html',
  styleUrls: ['./my-button-dialog.component.scss']
})
export class MyButtonDialogComponent implements OnInit {

  @Input() valid:boolean = false;
  @Input() title:string = "";
  @Input() icon:string = "";
  @Output() myClick =  new EventEmitter();

  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

  onClick(){
    this.myClick.emit();
  }


}
